// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import LabIcon from '../../../../../../../assets/images/card-lab-icon.svg';
import AssessmentIcon from '../../../../../../../assets/images/card-assessment-icon.svg';
import VodIcon from '../../../../../../../assets/images/card-vod-icon.svg';
import ChallengeIcon from '../../../../../../../assets/images/challenge-icon-in-card.svg';
import HyperlinkIcon from '../../../../../../../assets/images/hyperlink-icon.svg';
import TextIcon from '../../../../../../../assets/images/text-icon.svg';
import { ModuleType } from '../../../../../../../types/Model';
import { Link } from 'react-router-dom';
import CompletionStatusTag from '../../../../../../CompletionStatusTag';

const renderIcon = (type:ModuleType) => {
  switch (type) {
    case ModuleType.LAB:
      return LabIcon;
    case ModuleType.VIDEO:
      return VodIcon;
    case ModuleType.QUIZ:
      return AssessmentIcon;
    case ModuleType.HYPERLINK:
      return HyperlinkIcon;
    case ModuleType.ASSESSMENT:
      return AssessmentIcon;
    case ModuleType.CHALLENGE:
      return ChallengeIcon;
    case ModuleType.EXAM:
      return AssessmentIcon;
    case ModuleType.TEXT:
      return TextIcon;
    default:
      return null;
  }
}

const otherS = {
  TitleContainer: styled.div`
    display: flex;
    align-items: flex-start;
  `,
  Icon: styled.img.attrs<{ type: ModuleType }>(
    props => ({ src: renderIcon(props.type), alt: 'module-icon'}))<{ type: ModuleType }>`
    flex-shrink: 0;
    margin-right: 8px;
    width: 24px;
    height: 24px;
  `,
  Title: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #666666;
    transition: color 0.5s;
    display: inline-flex;
  `,
  FooterContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 36px;
    padding-right: 18px;
  `,
  DurationText: styled.div`
    font-size: 16px;
    line-height: 26px;
    color: #313131;
    margin-right: 21px;
  `,
  CompletionStatusTag: styled(CompletionStatusTag)`
    margin-left: auto;
  `,
  LinkIcon: styled.img`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  `,
};

const Container = styled.div`
  display: block;
  background: #FFF;

  & + & {
    border-top: #DEDEDE solid 1px;
  }
`;

export const S = {
  Container,
  Link: styled(Link)<{ active: boolean }>`
    display: block;
    padding: 14px 13px 10px 8px;
    transition: background 0.5s;

    & > div + div {
      margin-top: 9px;
    }

    &:hover {
      background: rgba(201, 201, 201, 0.3);
    }

    &:hover ${otherS.Title} {
      color: #EF8200;
    }

    border-left: 8px solid ${(props) => props.active ? '#EF8200' : 'transparent'};

    ${otherS.Title} {
      ${(props) => {
        if (props.active) {
          return {
            fontWeight: 'bold',
            color: '#EF8200'
          }
        }
      }}
    }
  `,
  TextContainer: styled.div`
    display: flex;
    align-items: flex-start;
    padding: 4px 0 6px;
  `,
  TextModuleTitle: styled(otherS.Title)`
    font-style: italic;
  `,
  ...otherS
}
